<template>
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 17C17 14.5147 19.0147 12.5 21.5 12.5H27.1446C28.4582 12.5 29.7063 13.074 30.5612 14.0714L33.1944 17.1435C34.3596 18.5028 35 20.2341 35 22.0244V23.8448C35 25.2668 34.7112 26.6739 34.151 27.9809L30.3832 36.7726C29.6741 38.4272 28.0471 39.5 26.247 39.5H21.5C19.0147 39.5 17 37.4853 17 35V17Z"
      fill="var(--sf-illustration-primary-background-primary)"
    />
    <path
      d="M12 12C12 9.23858 14.2386 7 17 7H23.2718C24.7314 7 26.1181 7.63781 27.068 8.74604L29.9938 12.1594C31.2884 13.6698 32 15.5934 32 17.5827V19.6053C32 21.1853 31.6791 22.7488 31.0567 24.2011L26.8702 33.9696C26.0823 35.808 24.2746 37 22.2745 37H17C14.2386 37 12 34.7614 12 32V12Z"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
    />
    <path
      d="M20.3333 20.3333C20.3333 19.4129 21.0795 18.6667 22 18.6667C22.9205 18.6667 23.6667 19.4129 23.6667 20.3333C23.6667 21.2538 22.9205 22 22 22C21.0795 22 20.3333 21.2538 20.3333 20.3333Z"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
    />
  </svg>
</template>
